import { render } from "./AllBride.vue?vue&type=template&id=4b1ce382"
import script from "./AllBride.vue?vue&type=script&lang=js"
export * from "./AllBride.vue?vue&type=script&lang=js"

import "./AllBride.vue?vue&type=style&index=0&id=4b1ce382&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroWeb\\marriage_beauro_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__